export const AGENCY_ZOOM_ORDER_VALUES = ["asc", "desc"] as const;

export const AGENCY_ZOOM_ORDER_LABEL_KEYS: Record<
  (typeof AGENCY_ZOOM_ORDER_VALUES)[number],
  string
> = {
  asc: "agencyZoomSearchCustomersSettings.orderAsc",
  desc: "agencyZoomSearchCustomersSettings.orderDesc",
};

export const AGENCY_ZOOM_CUSTOMER_STATUS_VALUES = ["all", "inactive", "active"] as const;

export const AGENCY_ZOOM_CUSTOMER_STATUS_LABEL_KEYS: Record<
  (typeof AGENCY_ZOOM_CUSTOMER_STATUS_VALUES)[number],
  string
> = {
  all: "agencyZoomSearchCustomersSettings.statusAll",
  inactive: "agencyZoomSearchCustomersSettings.statusInactive",
  active: "agencyZoomSearchCustomersSettings.statusActive",
};
